var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FlatpageLegalBase", [
    _c(
      "p",
      { staticClass: "intro" },
      [
        _vm._v(
          "\n    This is a previous version of the Privacy Policy that was in effect from March 24, 2014 until\n    May 21, 2018.\n    "
        ),
        !_vm.isMobile(_vm.$mq) ? _c("br") : _vm._e(),
        _vm._v(" "),
        _c(
          "router-link",
          { attrs: { to: { name: "flatpage_privacypolicy" } } },
          [_vm._v("\n      View the current Privacy Policy\n    ")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("h1", [_vm._v("Brilliant.org Privacy Statement")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        '\n    Brilliant Worldwide, Inc. ("Brilliant") knows that you care about how your personal\n    information is used and shared, and we take your privacy seriously. Please read the following\n    to learn more about our Privacy Statement. By using the brilliant.org website, or any of our\n    mobile applications (such as are available via the App Store and Google Play Store), and any\n    related services and/or features (collectively, the "Service") you acknowledge that you accept\n    the practices and policies outlined in this Privacy Statement.\n  '
      )
    ]),
    _vm._v(" "),
    _c("h3", { attrs: { id: "pp-two" } }, [
      _vm._v("What Does This Privacy Statement Cover?")
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        '\n    This Privacy Statement covers Brilliant\'s treatment of personally identifiable information\n    ("Personal Information") that Brilliant gathers when you access/use the Service.\n  '
      )
    ]),
    _vm._v(" "),
    _c("h3", { attrs: { id: "pp-three" } }, [
      _vm._v("What Personal Information Does Brilliant Collect?")
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    Brilliant collects information you voluntarily submit to the Service, such as, the information\n    we collect when you register for an account: your name, email address, school, date of birth,\n    etc.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        '\n    Information you elect to submit to the Service in a public or quasi-public manner may be\n    disclosed to other users of the Application or the general public ("User Submission(s)"). For\n    example - if you make a post to a message board or chat forum that includes any personal\n    information – such information will be made publicly available. We endeavor to make sure the\n    Service\'s functionality puts you on reasonable notice as to the scope of an intended\n    submission.\n  '
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    In addition, we may automatically receive and store certain, anonymous types of information\n    whenever you interact with the Service. Such information may include the user's IP address,\n    domain server, and type of Internet browser. This information helps us, among other things,\n    analyze trends and administer the Service. This information is anonymous and contains no\n    personally identifiable data.\n  "
      )
    ]),
    _vm._v(" "),
    _c("h3", { attrs: { id: "pp-four" } }, [_vm._v("What about children?")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    The safety and privacy of children is extremely important to us. Every Service member must be\n    over 13 years of age. Minors younger than 13 are prohibited from signing up or using the\n    Service in any way. If we receive information that a member is under 13, we require the member\n    to provide evidence of being over 13. If such evidence is not provided in a timely manner, we\n    terminate the user's account and nullify all personally identifiable information displaying on\n    the site and collected from such user.\n  "
      )
    ]),
    _vm._v(" "),
    _c("h3", { attrs: { id: "pp-five" } }, [
      _vm._v("How does Brilliant use the information it collects?")
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [
        _vm._v(
          "\n      Provide the Service: Your information will be used primarily to provide you with the\n      Service.\n    "
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "\n      Improve the Service: Your information may be used by us internally to improve the Service\n      and develop new products, services and features.\n    "
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Other Uses: Your information may also be used by us as set forth in the next section."
        )
      ])
    ]),
    _vm._v(" "),
    _c("h3", { attrs: { id: "pp-six" } }, [
      _vm._v(
        "Will Brilliant Share Any of the Personal Information it Receives?"
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    To the limited extent we collect Personal Information – we neither rent nor sell your Personal\n    Information to anyone. We share your Personal Information only as described below.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _c("em", [_vm._v("Foundations:")]),
      _vm._v(
        " Brilliant may disclose your name, contact info, school, and aggregate\n    information about your ability level to educational foundations that are working with\n    Brilliant so such foundations can identify talented individuals, award scholarships and/or\n    grants, and provide mentorship.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _c("em", [_vm._v("Recipient of User Submissions:")]),
      _vm._v(
        " As mentioned above – your User Submissions may be\n    shared in a public or quasi-public manner.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _c("em", [_vm._v("Service Providers and Agents:")]),
      _vm._v(
        " We employ other companies and people to perform tasks\n    on our behalf. For example, we may decide to use a third party payment processing company to\n    process payments you make through the Service. In addition, parts of the Service may be hosted\n    by a third party on our behalf. Your information may be accessed by such providers/agents, in\n    the event that we need to share your information with them to provide our services or customer\n    support to you. Unless we tell you differently, Brilliant's agents do not have any right to\n    use Personal Information we share with them beyond what is necessary to assist us.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _c("em", [_vm._v("Business Transfers:")]),
      _vm._v(
        " In some cases, we may choose to buy or sell assets. In these\n    types of transactions, customer information is typically one of the business assets that are\n    transferred. Moreover, if Brilliant, or substantially all of its assets were acquired, or in\n    the unlikely event that Brilliant goes out of business or enters bankruptcy, customer\n    information would be one of the assets that is transferred or acquired by a third party. You\n    acknowledge that such transfers may occur, and that any acquirer of Brilliant may continue to\n    use your Personal Information as set forth in this policy.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _c("em", [_vm._v("Protection of Brilliant and Others:")]),
      _vm._v(
        " We may release Personal Information when we\n    believe in good faith that release is necessary to comply with the law; enforce or apply our\n    conditions of use and other agreements; or protect the rights, property, or safety of\n    Brilliant, our employees, our users, or others.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _c("em", [_vm._v("With Your Consent:")]),
      _vm._v(
        " Except as set forth above, you will be notified when your Personal\n    Information may be shared with third parties, and will be able to prevent the sharing of this\n    information.\n  "
      )
    ]),
    _vm._v(" "),
    _c("h3", { attrs: { id: "pp-seven" } }, [_vm._v("Conditions of Use")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    If you decide to access or use the Service, such access and use and any possible dispute over\n    privacy is subject to this Privacy Statement and our Terms of Use (located on our website),\n    including limitations on damages, disclaimer of warranties, and the application of California\n    state law.\n  "
      )
    ]),
    _vm._v(" "),
    _c("h3", { attrs: { id: "pp-eight" } }, [
      _vm._v("Third Party Websites/Services")
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    The Site may permit you to link to other websites on the Internet, and other websites may\n    contain links to the Site. These other websites are not under Brilliant control, and such\n    links do not constitute an endorsement by Brilliant of those other websites or the services\n    offered through them. The privacy and security practices of websites linked to or from the\n    Service are not covered by this Privacy Statement, and Brilliant is not responsible for the\n    privacy or security practices or the content of such websites.\n  "
      )
    ]),
    _vm._v(" "),
    _c("h3", { attrs: { id: "pp-nine" } }, [
      _vm._v("Opting out of all future emails")
    ]),
    _vm._v(" "),
    _c(
      "p",
      [
        _vm._v(
          "\n    If you would like to stop receiving email from Brilliant, simply visit the\n    "
        ),
        _c(
          "router-link",
          { attrs: { to: { name: "account_emailpreferences" } } },
          [_vm._v("\n      Email section of your Account settings\n    ")]
        ),
        _vm._v("\n    and uncheck any and all boxes.\n  ")
      ],
      1
    ),
    _vm._v(" "),
    _c("h3", { attrs: { id: "pp-ten" } }, [
      _vm._v("Changes to this Privacy Statement")
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    Brilliant may amend this Privacy Statement from time to time. Use of information we collect\n    now is subject to the Privacy Statement in effect at the time such information is used. If we\n    make changes in the way we use Personal Information, we will notify you by posting an\n    announcement on our website, or via the Service, or sending you an email. Users are bound by\n    any changes to the Privacy Statement when he or she uses the Service after such changes have\n    been first posted.\n  "
      )
    ]),
    _vm._v(" "),
    _c("h3", { attrs: { id: "pp-eleven" } }, [_vm._v("Questions or Concerns")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    If you have any questions or concerns regarding privacy, please send us a detailed message at\n    support@brilliant.org. We will make every effort to resolve your concerns.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [_c("em", [_vm._v("Effective Date: March 24, 2014")])]),
    _vm._v(" "),
    _c("p", [
      _vm._v("\n    Tiffany Wang"),
      _c("br"),
      _vm._v("\n    15 Butte Place"),
      _c("br"),
      _vm._v("\n    San Francisco, CA 94103"),
      _c("br"),
      _vm._v("\n    (650) 468-2966\n  ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }